/**
 * @typedef {Object} CartItem
 * @property {string} id
 * @property {string} name
 * @property {string} category
 * @property {number} price
 * @property {number} quantity
 * @property {string} variantKey
 * @property {string} [variantLabel]
 * @property {string} [image]
 * @property {number} [stock]
 */

import React, { createContext, useState, useContext } from "react";
import { addCartItem, removeCartItem, updateCartQuantity } from "../lib/cartUtils";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [items, setItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [email, setEmail] = useState("");

  const setPlan = (plan) => {
    setSelectedPlan(plan);
    if (plan) {
      setIsCartOpen(true);
    }
  };

  const addItem = (item) => {
    setItems((prev) => addCartItem(prev, item));
  };

  const updateQuantity = (id, variantKey, delta) => {
    setItems((prev) => updateCartQuantity(prev, id, variantKey, delta));
  };

  const removeItem = (id, variantKey) => {
    setItems((prev) => removeCartItem(prev, id, variantKey));
  };

  const clearCart = () => {
    setSelectedPlan(null);
    setItems([]);
    setIsCartOpen(false);
    setEmail("");
  };

  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);
  const toggleCart = () => setIsCartOpen((prev) => !prev);

  const value = {
    selectedPlan,
    setPlan,
    items,
    addItem,
    updateQuantity,
    removeItem,
    email,
    setEmail,
    isCartOpen,
    openCart,
    closeCart,
    toggleCart,
    clearCart,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
